<template>
  <div class="team-member">
    <div class="info">
      <div class="email">{{email}}</div>

      <div class="description">Paid through {{renewalDate}}</div>
    </div>

    <div class="action">
      <a class="btn secondary medium" v-if="onChange" @click="onChange">Change</a>
      <a class="btn secondary medium" v-if="onDelete" @click="onDelete">Delete</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'team-member',
  props: {
    email: String,
    onRemove: Function,
    index: Number,
    renewalDate: String,
    model: Object,
    onChange: Function,
    onDelete: Function,
  },
};
</script>

<style lang="scss" scoped>
  .team-member {
    margin-bottom: 25px;

    @include media($notMobile) {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  .description {
    font-size: 14px;
    opacity: .5;
  }

  .action {
    @include media($notMobile) {
      margin-left: 20px;
    }

    @include media($mobile) {
      margin-top: 15px;
    }
  }
</style>
